import { Link } from 'react-router-dom';

export default function CategorySection() {
  const categories = [
    {
      id: 1,
      title: 'Gaming Tech',
      description: 'Reviews and recommendations for the best gaming peripherals, monitors, and accessories.',
      image: 'https://public.readdy.ai/ai/img_res/d224b98385ab9f28c77db16db7a3ace9.jpg',
      link: '/gaming',
      gradient: 'from-purple-600/80 via-purple-900/60 to-black/90',
      buttonText: 'View Gaming Setup Guides',
    },
    {
      id: 2,
      title: 'Streaming Equipment',
      description: 'Find the best microphones, cameras, and lighting for professional-quality streams.',
      image: 'https://readdy.ai/api/search-image?query=A%20professional%20streaming%20setup%20with%20studio%20microphone%20on%20boom%20arm%20ring%20light%20and%20HD%20webcam%20on%20a%20clean%20modern%20desk%20with%20soft%20cyan%20and%20purple%20ambient%20lighting%20in%20a%20contemporary%20streaming%20room%20with%20minimalist%20dark%20background&width=1200&height=600&seq=cat2&orientation=landscape',
      link: '/streaming',
      gradient: 'from-cyan-600/80 via-cyan-900/60 to-black/90',
      buttonText: 'View Streaming Gear Guides',
    },
    {
      id: 3,
      title: 'Office Productivity',
      description: 'Upgrade your workspace with monitors, keyboards, and accessories built for productivity.',
      image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20office%20workspace%20with%20large%20ultrawide%20monitor%20wireless%20keyboard%20and%20mouse%20on%20a%20minimalist%20white%20desk%20with%20natural%20lighting%20and%20green%20plants%20in%20a%20bright%20contemporary%20office%20with%20simple%20dark%20background&width=1200&height=600&seq=cat3&orientation=landscape',
      link: '/office',
      gradient: 'from-emerald-600/80 via-emerald-900/60 to-black/90',
      buttonText: 'View Productivity Setup Guides',
    }
  ];

  return (
    <section className="py-12 bg-transparent relative overflow-hidden">
      {/* Subtle cyan tinted overlay */}
      <div className="absolute inset-0 bg-cyan-900/8"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="inline-block px-4 py-2 border border-white/20 rounded-full text-xs uppercase tracking-widest text-white/80 backdrop-blur-sm mb-4">
            <span className="inline-block w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
            Browse by Category
          </div>
          <h2 className="text-5xl font-bold text-white mb-4">
            Explore by Category
            <div className="h-1 w-32 bg-gradient-to-r from-cyan-500 via-purple-500 to-cyan-500 mx-auto mt-4 rounded-full shadow-lg shadow-cyan-500/50"></div>
          </h2>
          <p className="text-lg text-gray-400">Find the best tech for your specific needs.</p>
        </div>

        {/* Categories Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <div
              key={category.id}
              className="group relative h-80 rounded-2xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-500 hover:shadow-2xl hover:shadow-purple-500/10"
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                />
                {/* Enhanced Dark Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-t ${category.gradient}`}></div>
              </div>

              {/* Content */}
              <div className="relative h-full flex flex-col justify-end p-8">
                <h3 className="text-3xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">
                  {category.title}
                </h3>
                <p className="text-gray-200 mb-6 leading-relaxed">
                  {category.description}
                </p>
                <Link
                  to={category.link}
                  className="inline-block px-6 py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-lg font-semibold hover:bg-white/20 hover:border-white/40 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                >
                  {category.buttonText}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}